export interface Goal {
  id: string;
  title: string;
  description: string;
  category: GoalCategory;
  status: GoalStatus;
  targetDate?: string;
  startedDate?: string;
  createdDate: string;
  completedDate?: string;
  notes?: string;
  progress: number; // 0-100 percentage
  milestones: Milestone[];
  parent_goal_id?: number | null;
  children?: Goal[]; // For hierarchical display
  metric_name?: string;
  starting_metric_value?: number;
  target_metric_value?: number;
}

export enum GoalCategory {
  PERSONAL = 'personal',
  CAREER = 'career',
  HEALTH = 'health',
  EDUCATION = 'education',
  FINANCE = 'finance',
  RELATIONSHIPS = 'relationships',
  HOBBIES = 'hobbies',
  TRAVEL = 'travel',
  LIFETIME = 'lifetime',
  FAMILY = 'family',
  MIND = 'mind',
  OTHER = 'other'
}



export enum GoalStatus {
  NOT_STARTED = 'not_started',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  ON_HOLD = 'on_hold',
  CANCELLED = 'cancelled'
}

export interface Milestone {
  id: string;
  title: string;
  description?: string;
  targetDate?: string;
  completedDate?: string;
  isCompleted: boolean;
}

export interface GoalFilters {
  category?: GoalCategory;
  status?: GoalStatus;
  searchQuery?: string;
  sortBy?: 'title' | 'createdDate' | 'targetDate' | 'progress';
  sortOrder?: 'asc' | 'desc';
}

export interface GoalFormData {
  title: string;
  description: string;
  category: GoalCategory;
  targetDate?: string;
  startedDate?: string;
  notes?: string;
  metric_name?: string;
  target_metric_value?: number;
}

export interface GoalPlan {
  id: string;
  title: string;
  description: string;
  steps: PlanStep[];
  createdDate: string;
  updatedDate?: string;
}

export interface PlanStep {
  id: string;
  title: string;
  description?: string;
  isCompleted: boolean;
  dueDate?: string;
  completedDate?: string;
  order: number;
}

export interface GoalHabit {
  id: string;
  title: string;
  description?: string;
  frequency: HabitFrequency;
  targetCount: number;
  currentStreak: number;
  longestStreak: number;
  createdDate: string;
  isActive: boolean;
}

export enum HabitFrequency {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly'
}

export interface SubGoal {
  id: string;
  title: string;
  description: string;
  status: GoalStatus;
  progress: number;
  targetDate?: string;
  createdDate: string;
  completedDate?: string;
}

export interface GoalProgressHistory {
  snapshot_date: string;
  progress_percentage: number;
  habit_progress: number | null;
  task_progress: number | null;
  current_metric_value: number | null;
  target_metric_value: number | null;
  calculation_method: string;
}
